module.exports = __webpack_public_path__ + "static/media/service-banner.af7b92f7.jpg";